import AuthService from '@/services/authService'
import PainelClientService from '@/services/bussines/painelCliente.service'

const savedProfile = localStorage.getItem('user_profile')

const state = {
  isAuthenticated: !!savedProfile, // Fica true se houver um perfil salvo
  userProfile: savedProfile ? JSON.parse(savedProfile) : null,
}

const actions = {
  // login({ commit }, payload) {
  //   commit('SET_USER', {user_id:'123', user_email:'test@example.com', user_roles:['user'], scope:'read', expires_in:3600}, null)
  // }
  async login({ commit }, payload) {
    try {
      // Executa o login. O navegador vai receber e salvar o Cookie HttpOnly automaticamente aqui!
      const data = await AuthService.login(payload.username, payload.password, payload.code)

      // Atualiza o estado da aplicação dizendo que ele está logado
      commit('SET_AUTH', true)
      
      //console.log("==> Dados recebidos do AuthService.login:", data)
     if (data) {
        const roles = data.user_roles || data.role || []
        
        // Normaliza para array caso seja apenas uma string (ex: "Client" ou "Consultoria")
        const rolesArray = Array.isArray(roles) ? roles : [roles]
        
        // Verifica se possui 'Client' ou 'Consultoria' (ajuste o texto exato da role se necessário)
        const isClientOrConsulting = rolesArray.some(role => 
          ['Client', 'Consultoria'].includes(role)
        )

        const customerInfo = isClientOrConsulting ? await PainelClientService.CustomerInfoConsult() : null

        commit('SET_USER', { userManager: data, customerInfo })
      }

      return data
    } catch (error) {
      commit('SET_AUTH', false)
      throw error
    }

 
  },
  async loginClient({ commit }, { username, password, code }) {
    let response = null

    try {
      response = await AuthService.loginClient(username.trim(), password.trim(), code)

        // Atualiza o estado da aplicação dizendo que ele está logado
      commit('SET_AUTH', true)

    } catch (error) {
      commit('SET_AUTH', false)
      throw error
    }

    if (response) {
      const roles = response.user_roles || response.role || []
      const isClient = Array.isArray(roles) ? roles.includes('Client') : roles.includes('Client')
      const customerInfo = isClient ? await PainelClientService.CustomerInfo() : null

      commit('SET_USER', { userManager: response, customerInfo })
    }
    return response
  },
  async changePassword({ commit }, { currentPassword, newPassword }) {
    try {
      const response = await AuthService.changePassword(currentPassword, newPassword)

      logout({ commit }) // Chama a ação de logout para limpar o estado
      return response

    } catch (error) {
      const ex = error.response.data
      throw ex
    }
  },
  // logout({ commit }) {
  //   // No logout, você limpa o estado do Vue
  //   commit('SET_AUTH', false)
  //   //commit('CLEAR_USER')

  // },
  async logout({ commit }) {
    try {
      // 1. Avisa o backend (opcional em JWT simples, obrigatório em Cookies/Refresh Tokens)
      await AuthService.logout()
    } catch (erro) {
      console.error("Erro ao notificar o backend sobre o logout:", erro)
    } finally {
      commit('SET_AUTH', false)
      commit('CLEAR_USER')
    }
  }
}

const mutations = {
  SET_AUTH(state, status) {
    state.isAuthenticated = status
  },
  SET_USER(state, { userManager, customerInfo }) {
    const profile = {
      id: userManager.user_id,
      email: userManager.user_email,
      role: userManager.user_roles || userManager.role,
      scope: userManager.scope,
      exp: userManager.expires_in,
      name: customerInfo != null ? customerInfo.Name : "Cliente",
      clienteId: customerInfo != null ? (customerInfo.RID || customerInfo.rid) : null
    }
    state.userProfile = profile

    try {
      localStorage.setItem('user_profile', JSON.stringify(profile))
      console.log("==> user_profile SALVO no localStorage com sucesso:", profile)
    } catch (e) {
      console.error("==> Erro crítico ao salvar no localStorage:", e)
    }

    // localStorage.setItem('user_profile', JSON.stringify(profile))
    // console.log('Perfil do usuário atualizado:', profile)
  },
  CLEAR_USER(state) {
    state.userProfile = null
    localStorage.removeItem('user_profile')
  }
}

const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  userRole: (state) => state.userProfile ? state.userProfile.role : null,
  userOnline: (state) => state.userProfile ? state.userProfile : null,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
// const actions = {
//     async login({ commit }, payload) {

//         commit('SET_ACCESS_TOKEN', null)
//         commit('SET_USER_PROFILE', null)

//         let response = null

//         try{
//             // response = await AuthService.login(username, password,code)
//             const code = payload.code || payload.Code || null;
//             response = await AuthService.login(payload.username, payload.password, code)

//             commit('SET_ACCESS_TOKEN', response.id_token)

//         }catch(error){
//             commit('SET_ACCESS_TOKEN', null)
//             commit('SET_USER_PROFILE', null)

//             throw error
//         }

//         if(response){
//             const userManager = jwtDecode(response.id_token)
//             const profile = {
//                 jti: userManager.jti,
//                 id: userManager.sub,
//                 email: userManager.email,
//                 role: userManager.role,
//                 scope: userManager.scope,
//                 exp:  userManager.exp,
//             }
//             commit('SET_USER_PROFILE', profile)
//         }

//         return response
//     },
//     async loginClient({ commit }, { username, password }) {
//         commit('SET_ACCESS_TOKEN', null)
//         commit('SET_USER_PROFILE', null)

//         let response = null

//         try{
//             response = await AuthService.loginClient(username.trim(), password.trim())

//             commit('SET_ACCESS_TOKEN', response.id_token)
//         }catch(error){
//             commit('SET_ACCESS_TOKEN', null)
//             commit('SET_USER_PROFILE', null)

//             const ex = error.response.data
//             console.error('Erro de login:', ex)
//             return ex
//         }

//         if(response){
//             const userManager = jwtDecode(response.id_token)

//             const customerInfo = await PainelClientService.CustomerInfo()

//             const profile = {
//                 jti: userManager.jti,
//                 id: userManager.sub,
//                 email: userManager.email,
//                 role: userManager.role,
//                 scope: userManager.scope,
//                 exp:  new Date(userManager.exp).toUTCString(),
//                 name: customerInfo != null ? customerInfo.Name : "Cliente"
//             }
//             commit('SET_USER_PROFILE', profile)
//         }
//         return response
//     },
//     async changePassword({ commit }, { currentPassword, newPassword }) {
//         try {
//             const response = await AuthService.changePassword(currentPassword, newPassword)

//             return response
//         } catch (error) {
//             const ex = error.response.data
//             throw ex
//         }
//     },
//     logout({ commit }) {
//         commit('SET_ACCESS_TOKEN', null)
//         commit('SET_USER_PROFILE', null)
//     },
// }
